import React, { Fragment, useEffect, useState } from 'react';
import { useAxios } from '@/hooks/useAxios';
import { useInterval } from '@/hooks/useInterval';
import { useTabVisibility } from '@/hooks/useTabVisibility';

interface IProps {
  roomId: string;
  interval?: number;
  children: React.ReactElement;
}

type Data = {
  count: number;
};

function dataHasCount(data: any): data is Data {
  return data && 'count' in data;
}

function Observer({ roomId, interval, children }: IProps) {
  const [participants, setParticipants] = useState<number>(0);

  const { data, error, send } = useAxios();

  const { prevState, isActive } = useTabVisibility();

  const hasTimedout = !isActive || error !== undefined;

  const onInterval = interval ? interval : 30000;

  const request = { url: `/api/visitor/rooms/${roomId}/participants` };

  useInterval(
    () => {
      send({ ...request });
    },
    hasTimedout ? null : onInterval
  );

  useEffect(() => {
    if (!prevState && isActive) {
      send({ ...request });
    }

    if (data === undefined) {
      send({ ...request });
    }

    if (dataHasCount(data) && data.count !== participants) {
      setParticipants(data.count);
    }
  }, [data, isActive]);

  const wrappedChildren = React.Children.map<
    React.ReactNode,
    React.ReactElement<{ participants: number }>
  >(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { participants });
    }

    return child;
  });

  return <Fragment>{wrappedChildren}</Fragment>;
}

export { Observer };
